import React from 'react';
import './Contact.scss';
import DescItem from '../../components/DescItem/DescItem';
import SimpleMap from '../../components/GoogleMapLocation/MapLocation';
import { contactDetails as contactDetailValues } from '../../utils/contact';

const Contact = () => {
    const iconStyle = {
        color: 'gray',
        size: '18',
    };
    const contactDetails = [
        {
            label: 'Adress',
            value: contactDetailValues.address,
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 384 512"
                    width={iconStyle?.size}
                    height={iconStyle?.size}
                    fill={iconStyle?.color}
                >
                    <path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 256c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z" />
                </svg>
            ),
        },
        {
            label: 'Phone',
            value: contactDetailValues.phone,
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    width={iconStyle?.size}
                    height={iconStyle?.size}
                    fill={iconStyle?.color}
                >
                    <path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z" />
                </svg>
            ),
        },
        {
            label: 'Fax',
            value: contactDetailValues.fax,
            icon: (
                <svg
                    viewBox="0 0 12 12"
                    xmlns="http://www.w3.org/2000/svg"
                    width={iconStyle?.size}
                    height={iconStyle?.size}
                    fill={iconStyle?.color}
                >
                    <g>
                        <rect height="3" width="7" x="2.5" y="8.5" />
                        <polygon points="10,3 10,0.5 3.5,0.5 2,2 2,3  " />
                        <path d="M10.5,4h-9C0.6728516,4,0,4.6728516,0,5.5V10h1.5V7.5h9V10H12V5.5C12,4.6728516,11.3271484,4,10.5,4z    M10,6.5H9v-1h1V6.5z" />
                    </g>
                </svg>
            ),
        },
        {
            label: 'Email',
            value: contactDetailValues.email,
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    width={iconStyle?.size}
                    height={iconStyle?.size}
                    fill={iconStyle?.color}
                >
                    <path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z" />
                </svg>
            ),
        },
        {
            label: 'Business hours',
            value: 'Monday - Friday: 9:00 AM - 5:00 PM',
            icon: (
                <svg
                    viewBox="0 0 32 32"
                    width={iconStyle?.size}
                    height={iconStyle?.size}
                    fill={iconStyle?.color}
                >
                    <path d="M16,10c-1.104,0-2,0.896-2,2v5.2l-1.408,1.407C12.092,19.107,12,19.578,12,20c0,1.104,0.896,2,2,2  c0.578,0,1.04-0.241,1.392-0.592l2.071-2.07C17.76,19.041,18,18.578,18,18v-6C18,10.896,17.104,10,16,10z M16,4  C8.268,4,2,10.268,2,18c0,3.151,1.054,6.05,2.811,8.39l-2.23,2.23C2.193,29.006,2,29.469,2,30c0,1.188,1.016,2,2,2  c0.516,0,0.986-0.186,1.38-0.58l2.23-2.23C9.95,30.946,12.849,32,16,32s6.05-1.054,8.39-2.811l2.23,2.23  C27.014,31.814,27.484,32,28,32c0.984,0,2-0.813,2-2c0-0.531-0.193-0.994-0.58-1.38l-2.23-2.23C28.946,24.05,30,21.151,30,18  C30,10.268,23.732,4,16,4z M16,28c-5.522,0-10-4.478-10-10S10.478,8,16,8s10,4.478,10,10S21.522,28,16,28z M26,0  c-2.13,0-3.996,1.113-5.061,2.786c3.933,1.275,7.199,4.025,9.139,7.606C31.258,9.297,32,7.736,32,6C32,2.687,29.313,0,26,0z   M11.061,2.786C9.996,1.113,8.13,0,6,0C2.687,0,0,2.687,0,6c0,1.736,0.742,3.297,1.922,4.393C3.861,6.812,7.128,4.062,11.061,2.786z  " />
                </svg>
            ),
        },
    ];
    return (
        <>
            <section className="page-hero contact-hero top-padding-mobile">
                <div className="page-hero-container">
                    <div className="page-hero-content">
                        <div className="page-hero-badge">Get In Touch</div>
                        <h1 className="page-hero-title">Talk With a Mechanical Specialist</h1>
                        <p className="page-hero-description">
                            Have a question about an upcoming tender, a planned retrofit, or service support for your facility? We work closely with institutional teams to scope solutions, clarify timelines, and provide clear pricing. Reach out and we’ll pair you with a project lead who understands school, municipal, and public safety environments.
                        </p>
                        <div className="page-hero-stats">
                            <div className="hero-stat-item">
                                <div className="stat-number">&lt;24hr</div>
                                <div className="stat-label">Response Time</div>
                            </div>
                            <div className="hero-stat-item">
                                <div className="stat-number">Free</div>
                                <div className="stat-label">Consultations</div>
                            </div>
                            <div className="hero-stat-item">
                                <div className="stat-number">24/7</div>
                                <div className="stat-label">Emergency Support</div>
                            </div>
                        </div>
                    </div>
                    <div className="page-hero-visual">
                        <svg width="280" height="280" viewBox="0 0 280 280" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M140 40 L240 100 L240 180 L140 240 L40 180 L40 100 Z" stroke="rgba(0, 175, 207, 0.15)" strokeWidth="2" fill="none"/>
                            <path d="M140 80 L200 120 L200 160 L140 200 L80 160 L80 120 Z" stroke="rgba(0, 175, 207, 0.2)" strokeWidth="2" fill="none"/>
                            <circle cx="140" cy="140" r="50" stroke="rgba(0, 175, 207, 0.15)" strokeWidth="2" fill="none"/>
                            <circle cx="140" cy="140" r="30" fill="rgba(0, 175, 207, 0.08)"/>
                            <line x1="140" y1="90" x2="140" y2="190" stroke="rgba(0, 175, 207, 0.2)" strokeWidth="2"/>
                            <line x1="90" y1="140" x2="190" y2="140" stroke="rgba(0, 175, 207, 0.2)" strokeWidth="2"/>
                        </svg>
                    </div>
                </div>
            </section>

            <div className="section contact-container">
                <div className="contact-page-content">
                <div className="contact-details">
                    <h3 className="title contact-header-title">
                        Contact Details
                    </h3>
                    <div className="contact-items-wrap">
                        {contactDetails?.map((item, index) => (
                            <DescItem key={index} item={item} />
                        ))}
                    </div>
                </div>

                <div className="vertical-line"></div>
                <div className="map-container">
                    <h3 className="title contact-header-title">Office</h3>
                    <SimpleMap />
                </div>
            </div>
        </div>
        </>
    );
};

export default Contact;
